import gql from 'graphql-tag';
import { QueryHookOptions } from '@apollo/react-hooks';

export const queryOptions: QueryHookOptions = {
  errorPolicy: 'all',
  notifyOnNetworkStatusChange: true,
  partialRefetch: true,
  context: {
    clientName: 'orchestration',
    useFhir: true
  }
};

/**
 * Action items are split by priority now to improve performance
 * We have split them into two groups
 *
 * Group 1 (High): Items for which we own most of the data locally, and so have control
 * over things like caching/tweaking queriest/performance.
 *
 * Group 2 (Low): Items for which we rely on a third party vendor or cerner,
 * which we have little to no control over their performance characteristics.
 */

export const GetHighPriorityActionItems = gql`
  query GetHighPriorityActionItems {
    getActionItems {
      announcements {
        id
        sourceId
        eventTypeId
        relatedData
      }

      antiCoagulation {
        eventId
        sourceId
        createdAt
      }

      healthAdvisories {
        eventId
        advisoryName
        advisoryType
        advisoryReferenceCD
        snoozeOptions {
          days
          nextSeason
        }
      }
    }
  }
`;

export const GetLowPriorityActionItems = gql`
  query GetLowPriorityActionItems {
    getActionItems {
      goals {
        activeCount
      }

      rtas {
        id
        sourceId
        eventTypeId
        relatedData
      }
    }
  }
`;
